function TableUtilitiesButtonWrapper({ children }) {
  return (
    <div className="flex flex-row items-center print:hidden justify-end">
      {children}
    </div>
  );
}

export default TableUtilitiesButtonWrapper;
